import { Injectable } from '@angular/core';
import { GlobalsService } from '../_services/globals.service';
import Keycloak, { KeycloakInstance } from 'keycloak-js';

@Injectable()
export class KeycloakService {
  static auth: any = {};
  static logouturl: string;

  constructor() {}

  public static async init(): Promise<void> {
    const keycloakAuth: KeycloakInstance = new (Keycloak as any)({
      url: window.location.origin + '/auth',
      realm: 'lek',
      clientId: 'lek-angular-devel'
    });
    KeycloakService.auth.loggedIn = false;

    const authenticated = await keycloakAuth.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      responseMode: 'query',
      redirectUri: window.location.origin + '/'
    });

    if (!authenticated) {
      await keycloakAuth.login({
        redirectUri: window.location.origin + '/'
      });
      return;
    }

    KeycloakService.auth.loggedIn = true;
    KeycloakService.auth.authz = keycloakAuth;
    KeycloakService.auth.logoutUrl =
      keycloakAuth.authServerUrl + KeycloakService.logouturl;
  }

  logout() {
    KeycloakService.auth.loggedIn = false;

    if (KeycloakService.auth.authz) {
      KeycloakService.auth.authz.logout({
        redirectUri: window.location.origin + '/'
      });
      return;
    }

    window.location.href = GlobalsService.getKeyCloakLogoutUrl();
  }

  getAccessToken(): string | null {
    return KeycloakService.auth?.authz?.token || null;
  }

  async getToken(minValiditySeconds = 30): Promise<string> {
    const authz = KeycloakService.auth?.authz;

    if (!authz || !authz.token) {
      throw new Error('Not logged in');
    }

    await authz.updateToken(minValiditySeconds);
    return authz.token;
  }

  refreshToken(minValiditySeconds = 30): Promise<string> {
    return this.getToken(minValiditySeconds);
  }
}